module.exports = __webpack_public_path__ + "img/wxlogo.a02413bf.png";